import { Enums } from '@bode-canada/core';
import { icons } from '@/components/maps/constants';

export default class MapsMarkerHelper {
  static getListingIcon(listing) {
    const { origin, status } = listing;
    const listingIsBode = origin === Enums.ListingOriginEnum.BODE;
    const listingIsSold = status === Enums.ListingStatusEnum.SOLD;

    if (listingIsBode) {
      return listingIsSold ? icons.BODE_SOLD : icons.BODE;
    }

    return icons.NOT_BODE;
  }

  static getGroupListingIcon(listing) {
    const { origin, status } = listing;
    const listingIsBode = origin === Enums.ListingOriginEnum.BODE;
    const listingIsSold = status === Enums.ListingStatusEnum.SOLD;

    if (listingIsSold) {
      return listingIsBode ? icons.BODE_SOLD_GROUP : icons.SOLD_GROUP;
    }

    return listingIsBode ? icons.BODE_GROUP : icons.NOT_BODE;
  }
}
